import '../assets/NcActionCheckbox-DG9SyAAy.css';
import { i as mdiCheckboxMarked, j as mdiCheckboxBlankOutline } from "./mdi-DkJglNiS.mjs";
import { ref, watch } from "vue";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-Bui9PhAS.mjs";
import { u as useModelMigration } from "./useModelMigration-EhAWvqDD.mjs";
import { A as ActionGlobalMixin } from "./actionGlobal-DqVa7c7G.mjs";
import { G as GenRandomId } from "./GenRandomId-F5ebeBB_.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcActionCheckbox",
  components: {
    NcIconSvgWrapper
  },
  mixins: [ActionGlobalMixin],
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: false
    }
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * id attribute of the checkbox element
     */
    id: {
      type: String,
      default: () => "action-" + GenRandomId(),
      validator: (id) => id.trim() !== ""
    },
    /**
     * Removed in v9 - use `modelValue` (`v-model`) instead
     *
     * @deprecated
     */
    checked: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: void 0
    },
    /**
     * checked state of the the checkbox element
     */
    modelValue: {
      type: Boolean,
      default: false
    },
    /**
     * value of the checkbox input
     */
    value: {
      type: [String, Number],
      default: ""
    },
    /**
     * disabled state of the checkbox element
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    /** Native change event */
    "change",
    /** Checkbox is checked */
    "check",
    /** Checkbox is unchecked */
    "uncheck",
    /**
     * Removed in v9 - use `update:modelValue` (`v-model`) instead
     *
     * @deprecated
     */
    "update:checked",
    /**
     * Emitted when the checkbox state is changed
     *
     * @type {boolean}
     */
    "update:modelValue",
    /** Same as update:modelValue for Vue 2 compatibility */
    "update:model-value"
  ],
  setup() {
    const model = useModelMigration("checked", "update:checked");
    const localModel = ref(model.value);
    watch(model, (newValue) => localModel.value = newValue, { flush: "sync" });
    watch(localModel, (newValue) => model.value = newValue, { flush: "sync" });
    return {
      localModel,
      mdiCheckboxBlankOutline,
      mdiCheckboxMarked
    };
  },
  methods: {
    onChange(event) {
      this.$emit("change", event);
      if (event.target.checked) {
        this.$emit("check");
      } else {
        this.$emit("uncheck");
      }
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("li", { staticClass: "action", class: { "action--disabled": _vm.disabled }, attrs: { "role": _vm.isInSemanticMenu && "presentation" } }, [_c("label", { staticClass: "action-checkbox", attrs: { "role": _vm.isInSemanticMenu && "menuitemcheckbox", "aria-checked": _vm.isInSemanticMenu && _vm.localModel.toString() } }, [_c("span", { staticClass: "action-checkbox__icon" }, [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.localModel, expression: "localModel" }], staticClass: "action-checkbox__input", class: { focusable: !_vm.disabled }, attrs: { "id": _vm.id, "type": "checkbox", "disabled": _vm.disabled }, domProps: { "value": _vm.value, "checked": Array.isArray(_vm.localModel) ? _vm._i(_vm.localModel, _vm.value) > -1 : _vm.localModel }, on: { "change": [function($event) {
    var $$a = _vm.localModel, $$el = $event.target, $$c = $$el.checked ? true : false;
    if (Array.isArray($$a)) {
      var $$v = _vm.value, $$i = _vm._i($$a, $$v);
      if ($$el.checked) {
        $$i < 0 && (_vm.localModel = $$a.concat([$$v]));
      } else {
        $$i > -1 && (_vm.localModel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
      }
    } else {
      _vm.localModel = $$c;
    }
  }, _vm.onChange] } }), _c("NcIconSvgWrapper", { attrs: { "path": _vm.localModel ? _vm.mdiCheckboxMarked : _vm.mdiCheckboxBlankOutline, "size": 20 } })], 1), _c("span", { staticClass: "action-checkbox__text" }, [_vm._v(_vm._s(_vm.text))])])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "7fbb3c95"
);
const NcActionCheckbox = __component__.exports;
export {
  NcActionCheckbox as N
};
//# sourceMappingURL=NcActionCheckbox-Cbg5yktN.mjs.map
